// icons/SafeBoxIcon.js
import React from 'react';

const SafeBoxIcon = ({
  size = 28,
  bgColor = "#EEF0FF",
  stroke = "#4338CA"
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "9999px",
        background: bgColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <svg
        width={32}
        height={25}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M5 8C5 5.5 7 4 9.5 4H14.5C17 4 19 5.5 19 8V16C19 18.5 17 20 14.5 20H9.5C7 20 5 18.5 5 16V8Z"
          stroke={stroke}
          strokeWidth="2"
          strokeLinejoin="round"
        />

        <path
          d="M9 11H15"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
        />

        <path
          d="M10 14H14"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default SafeBoxIcon;